import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=5f50159c&"
import script from "./AccountSettings.vue?vue&type=script&lang=ts&"
export * from "./AccountSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports